module.exports = __webpack_public_path__ + "static/fonts/Athiti-Medium.ttf.ad83b53.woff";